import { INK, PALETTE, SHADE, WORLD } from '@blorbs/common';
import type { Camera } from './camera';
import { circle, hash, inkStroke } from './art';

const SAND = PALETTE[4]; // butter
const SAND_SHADE = SHADE[SAND]!;
const SPECKLE = '#e3dcb4';
const SPECKLE_2 = '#efe1da';

/** Speckles stay put in world space and get swallowed as the island shrinks. */
const SPECKLES = Array.from({ length: 70 }, (_, i) => {
  const a = hash(i * 3 + 100) * Math.PI * 2;
  const d = Math.sqrt(hash(i * 3 + 101)) * 580;
  return { x: WORLD.cx + Math.cos(a) * d, y: WORLD.cy + Math.sin(a) * d, r: 3 + hash(i * 3 + 102) * 5, alt: i % 3 === 0 };
});

export function drawIsland(ctx: CanvasRenderingContext2D, cam: Camera, radius: number, shrinking: boolean, time: number): void {
  const { cx, cy } = WORLD;
  const thickness = 10;

  // Cliff face: the shaded disc offset downward gives the island a lip.
  ctx.fillStyle = SAND_SHADE;
  circle(ctx, cx, cy + thickness, radius);
  ctx.fill();
  inkStroke(ctx, 4, cam.scale);
  ctx.stroke();

  // Top surface.
  ctx.fillStyle = SAND;
  circle(ctx, cx, cy, radius);
  ctx.fill();

  ctx.save();
  ctx.clip();
  for (const s of SPECKLES) {
    ctx.fillStyle = s.alt ? SPECKLE_2 : SPECKLE;
    circle(ctx, s.x, s.y, s.r);
    ctx.fill();
  }
  // Crumbling edge while the island is shrinking: nibbled ink arcs at the rim.
  if (shrinking) {
    ctx.strokeStyle = SAND_SHADE;
    ctx.lineWidth = Math.max(6, 3 / cam.scale);
    for (let i = 0; i < 18; i++) {
      const a = (i / 18) * Math.PI * 2 + Math.sin(time * 2 + i) * 0.05;
      const span = 0.12 + hash(i + 300) * 0.1;
      ctx.beginPath();
      ctx.arc(cx, cy, radius - 6, a, a + span);
      ctx.stroke();
    }
  }
  ctx.restore();

  inkStroke(ctx, 4, cam.scale, INK);
  circle(ctx, cx, cy, radius);
  ctx.stroke();
}
